import CryptoJS from 'crypto-js';
function messageAsIs(message) { return (message || '').substring(0, 14) === 'SonarEncrypted' ? '******' : message; }
export function decrypt(encryptedMessage) {
    const ls = localStorage.getItem('tenantEncryptionKeys');
    if (!ls || ls === '')
        return messageAsIs(encryptedMessage);
    const lsObj = JSON.parse(ls);
    const dks = lsObj.decryptionKeys;
    if (!dks)
        return messageAsIs(encryptedMessage);
    let hashOfKeyUsed = '';
    // 14 is length of 'SonarEncrypted', 78 is 14 + 64; 64 is length of key hash
    try {
        hashOfKeyUsed = encryptedMessage.substring(14, 78);
    }
    catch (_a) {
        return messageAsIs(encryptedMessage);
    } // catching cases when message is shorter than 64, thus as such could not have been encrypted
    const matchingKey = dks[hashOfKeyUsed];
    if (!matchingKey)
        return messageAsIs(encryptedMessage);
    const em = encryptedMessage.substring(78); // removing 78 chars of 'SonarEncrypted' and hashkey
    const decryptedBytes = CryptoJS.AES.decrypt(em, matchingKey);
    const decryptedMessage = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedMessage;
}
